var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMentionableAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.217 10.713a1.275 1.275 0 00-.641-.836 1.117 1.117 0 00-1.006-.014l-10.28 4.996-.648-.344-2.309-1.205a.522.522 0 00-.5.008.676.676 0 00-.318.446c-.353 1.572-.353 5.402 0 6.972a.676.676 0 00.318.447c.158.087.34.09.5.007L13 20.32v5.43c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75v-5.291l2.287 1.11 1.637.809 4.646 2.26c.321.154.689.15 1.006-.015.317-.163.551-.47.641-.836.71-2.95.71-10.13 0-13.074z",
    fill: "#212121"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#BDBDBD"
  })));
}

export default __webpack_public_path__ + "1f6798b571881fd573b7bd7056c841b9.svg";
export { SvgIconMentionableAll as ReactComponent };